   document.addEventListener("DOMContentLoaded", function() {
    // Get the form and validation button
    const contactForm = document.getElementById('ContactForm');
    const validateButton = document.getElementById('validateButton');
    const submitButton = document.getElementById('ContactFormSubmitButton');

    // Attach event listener to the custom validation button
    validateButton.addEventListener('click', function() {
      // Get form inputs
      const emailInput = document.getElementById('ContactForm-email');
      const nameInput = document.getElementById('ContactForm-name');
      const helpInput = document.getElementById('ContactForm-help');
      const compInput = document.getElementById('ContactForm-company');
      const messageInput = document.getElementById('ContactForm-body');
      const countrySelect = document.getElementById('ContactForm-country');
      const checkbox = document.querySelector('.check_field__input');

      // Clear previous error messages
      clearErrors();

      // Perform validation checks
      let valid = true;

      // Validate email
      if (!validateEmail(emailInput.value)) {
        showError(emailInput, 'Please enter a valid email.');
        valid = false;
      }

      // Validate help
       if (helpInput.value.trim() === '') {
        showError(helpInput, 'Please select any option.');
        valid = false;
      }
      if (compInput.value.trim() === '') {
        showError(compInput, 'Please enter your company name.');
        valid = false;
      }
      if (nameInput.value.trim() === '') {
        showError(nameInput, 'Please enter your name.');
        valid = false;
      }

      // Validate message
      if (messageInput.value.trim() === '') {
        showError(messageInput, 'Please enter your message.');
        valid = false;
      }

      // Validate country
      if (countrySelect.value === '') {
        showError(countrySelect, 'Please select your country.');
        valid = false;
      }

      // Validate checkbox
      if (!checkbox.checked) {
        showError(checkbox, 'You must agree to the privacy policy.');
        valid = false;
      }

      // If valid, trigger form submission programmatically
      if (valid) {
        submitButton.click();  // Trigger the hidden submit button
      } else {
        // Scroll to the first error for better UX
        const firstError = document.querySelector('.input--error');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });

    // Utility functions

    // Show error message
    function showError(element, message) {
      const errorElement = document.createElement('div');
      errorElement.className = 'contact__field-error';
      errorElement.innerText = message;
      element.closest('.contact_field, .contact__field').appendChild(errorElement);
      element.classList.add('input--error');
    }

    // Clear all errors
    function clearErrors() {
      const errorElements = document.querySelectorAll('.contact__field-error');
      errorElements.forEach(function(errorElement) {
        errorElement.remove();
      });

      const errorInputs = document.querySelectorAll('.input--error');
      errorInputs.forEach(function(input) {
        input.classList.remove('input--error');
      });
    }

    // Validate email using a regex pattern
    function validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(String(email).toLowerCase());
    }
  });